export default [
	{
		tips: [
			{
				tip: 'Select one or more reports in the table and click on the copy button to copy them',
			},
		],
	},
];
